import React from 'react';
import PropTypes from 'prop-types';
import CONST from '@/utils/Constants/General';
import Icon from '@/components/atoms/Icon';
import useIterateModifiers from '@/hooks/useIterateModifiers';

const ButtonSocial = ({
  glyph,
  isGoogle,
  isPaypal,
  modifiers,
  text,
  title,
  onClick,
}) => {
  const modifiersString = useIterateModifiers('dln-btn--', modifiers);
  const iconName = () => {
    if (isGoogle) {
      return 'icons/icon-google+.svg';
    }
    if (isPaypal) {
      return 'logos/logo-paypal.svg';
    }
    return '';
  };

  return (
    <button
      type='button'
      className={`dln-btn ${modifiersString}`}
      title={title || text}
      onClick={onClick}
    >
      {isGoogle || isPaypal ? (
        <img
          alt=''
          className='dln-btn__icon'
          src={`${CONST.PATH.ASSETS.IMAGES}/${iconName()}`}
        />
      ) : (
        <Icon glyph={glyph} modifiers={modifiers} />
      )}
      <span className='dln-btn__lbl'>&nbsp;{text}</span>
    </button>
  );
};

ButtonSocial.propTypes = {
  glyph: PropTypes.string,
  isGoogle: PropTypes.bool,
  isPaypal: PropTypes.bool,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  text: PropTypes.string.isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ButtonSocial.defaultProps = {
  glyph: null,
  isGoogle: false,
  isPaypal: false,
  modifiers: [],
  title: null,
};

export default ButtonSocial;
